<template lang="pug">
  .col-24.flexD.alignItemsCenter.justifyCenter.l-padding-bottom-4em.m-padding-bottom-2em
    .col-16.flexD.flexDirectionColumn.minWidth768.m-minWidthAuto.m-width-90
      p.fontBold.font-title {{ title }}
      .col-24.flexD.flexWrap.justifySpaceBetween.flexDirectionRow.l-margin-top-4em.m-margin-top-2em
        a.c-product__item.c-product__item--big.l-margin-bottom-3em.m-margin-bottom-2em(v-for="(item, index) in insidePro" :key="100+index" @click="routeTo(item.src)")
          .c-product__item--img.initBackgroundImage(:style="{backgroundImage:'url('+ item.img +')'}")
          .c-product__item--link.col-24
            p {{ item.title }}
        a.c-product__item.l-margin-bottom-3em.m-margin-bottom-2em(v-for="(item, index) in products" :key="index" :href="item.url ? item.url : 'javascript:void(0)'" :target="item.url ? '_blank' : '_self'")
          .c-product__item--img.initBackgroundImage(:style="{backgroundImage:'url('+ item.img +')'}")
          .c-product__item--link.col-24
            p {{ item.title }}

</template>

<script>
  export default {
    name: 'whdProduct',
    props: ['content'],
    data(){
      return{
        title: this.$t('whd.products'),
        insidePro: [
          { title: this.$t('whd.product_9'), src:"whd_homepage", img: require('@/assets/img/whd/SoundPicture.png') },
        ],
        products: [
          { title: this.$t('whd.product_1'), url: "https://whd.de/products/a-250-weiss?_pos=2&_sid=38a3b6fcd&_ss=r", img: require('@/assets/img/whd/A250_S_WS_001_2048x2048.png') },
          { title: this.$t('whd.product_2'), url: "https://whd.de/products/s-350-8-s-weiss", img: require('@/assets/img/whd/S350_S30_WS_001_2048x2048.png') },
          { title: this.$t('whd.product_3'), url: "https://whd.de/products/amp-4200-schwarz?_pos=1&_sid=fa6fca2b6&_ss=r", img: require('@/assets/img/whd/AMP4200_S_SW_001_2048x2048.png') },
          { title: this.$t('whd.product_4'), url: "", img: require('@/assets/img/whd/TP4200.png') },
          { title: this.$t('whd.product_5'), url: "https://whd.de/products/sdl-400-s-silber?_pos=1&_sid=3f1f76916&_ss=r", img: require('@/assets/img/whd/SDL400_F_GR_001_e3eb5005-7ed3-4c9f-aa4b-6b037f13e91b_2048x2048.png') },
          { title: this.$t('whd.product_6'), url: "https://whd.de/collections/invisible-lautsprecher/products/wavebreaker", img: require('@/assets/img/whd/WAVEBREAKER_SR_001_2048x2048.png') },
          { title: this.$t('whd.product_7'), url: "https://whd.de/products/blende-agbw-m240-s", img: require('@/assets/img/whd/M240_F_AGBWA_001_2048x2048.png') },
          { title: this.$t('whd.product_8'), url: "https://whd.de/products/up-14-8-weiss?_pos=1&_sid=a55eb857a&_ss=r", img: require('@/assets/img/whd/UP14-26_F_WS_001_2048x2048.png') },
        ],
      }
    },
    computed: {},
    methods:{
      routeTo(url){
        this.$router.push({
          name: url
        })
      },
    },
    created(){}
  }
</script>
